import {useState} from 'react';
import { MenuItem, Select, Tooltip } from '@mui/material'
import DownloadIcon from '@mui/icons-material/Download';
import { useStyles } from '../SelectIconStyles';
import { ExportCsv, ExportPdf } from '@material-table/exporters';
import { SelectExportTypeProps } from '../../../pages/get-quote/models';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { checkErrorAPICall } from '../../../helpers/checkErrorAPICall';
import { RootState } from '../../../../setup';
import { insertAtIndex } from '../../TrackingGridPage/columnsTrackingGrid';
import { dollarUSLocale } from '../../../helpers/dollarUSLocale';

const GET_SHIPPINGLOCATIONS = '/api/v1/database/shippinglocation'
const GET_SHIPPINGITEMS = '/applet/v1/database/shippingitem'
const GET_QUOTES = '/api/v1/database/quote'
const GET_INVOICES = '/applet/v1/invoice'
const GET_TRACKINGS = '/applet/v1/book'
const GET_VENDORS = '/applet/v1/database/vendor'
const GET_COLLECTSL = 'api/v1/collectbilltodata'

const SelectExportType = ({columns, dataColumns, fileName, disabled, setLoading, filters, columnsTrackingGrid, ascOrDesc, field, filtersForData}: SelectExportTypeProps) => {
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number
    const classes = useStyles({disabled: false, fontSize: fontSize})
    const dispatch = useDispatch()
    const [tooltipOpen, setTooltipOpen] = useState(false)

    const menuProps = {
        classes: {
            list: classes.list
        }
    }

    const downloadFile = (value) => {
        if(value === 'pdf'){
            ExportPdf(columns, dataColumns, fileName)
        }else if(value === 'csv'){
            ExportCsv(columns, dataColumns, fileName)
        }else{
            setLoading(true)
            if(fileName === 'Invoices'){
                axios.post(`/applet/v1/invoice/export?columns[]=${columns.map(c => c.field).join("|")}&${filtersForData.dueDaysFrom ? `dueDaysFrom=${filtersForData.dueDaysFrom || undefined}` : null}&${filtersForData.dueDaysTo ? `dueDaysTo=${filtersForData.dueDaysTo || undefined}` : null}&${filtersForData.paid === true || filtersForData.paid === false ? `paid=${filtersForData.paid || undefined}` : null}&invoiceNumber=${filtersForData.invoiceNumber}`).then((results) => {
                    let timer = setInterval(() => {
                        axios.get(`/applet/v1/invoice/export/${results.data.data.results.identifier}/progress`).then((resultsProgress) => {
                            if(resultsProgress.data.data.results.progress === 100){
                                clearInterval(timer)
                                axios.get(`/applet/v1/invoice/export/${results.data.data.results.identifier}/download`).then((res) => {
                                    let fileName = "Invoices.csv";
                                    let blob = new Blob([res.data], {
                                        encoding: "UTF-8",
                                        type: "text/csv;charset=UTF-8"
                                    });
                                    let blobUrl = URL.createObjectURL(blob);
    
                                    let link = document.createElement('a');
                                    link.href = blobUrl;
                                    link.download = fileName;
                                    link.click();
                                    setLoading(false)
                                }).catch(() => {
                                    setLoading(false)
                                })
                            }
                        }).catch(() => {
                            setLoading(false)
                        })
                    }, 1000);
                }).catch(() => {
                    setLoading(false)
                })
            }else{
                const getCurrentFile = (fileName) => {
                    // fileName === 'ShippingLocations' ? GET_SHIPPINGLOCATIONS : fileName === 'ShippingItems' ? GET_SHIPPINGITEMS : fileName === 'Trackings' ? GET_TRACKINGS : fileName === 'Vendors' ? GET_VENDORS : GET_QUOTES
                    let url;
                        switch (fileName) {
                            case 'ShippingLocations':
                            url = GET_SHIPPINGLOCATIONS
                            break;
                            case 'ShippingItems':
                            url = GET_SHIPPINGITEMS
                            break;
                            case 'Trackings':
                            url = GET_TRACKINGS
                            break;
                            case 'Vendors':
                            url = GET_VENDORS
                            break;
                            case 'collect':
                            url = GET_COLLECTSL
                            break;
                            default:
                            url = GET_QUOTES
                        }

                    return url;
                }
                axios.get(getCurrentFile(fileName), {
                    params: filtersForData ? filtersForData : {}
                })
                .then((results) => {
                    
                    let newResults = results.data.data.results?.map(r => {
                        let displayTotal = r?.totalDue;

                        if (r?.totalDue === "0" && r?.invoiced && r?.invoiceAmount) {
                            displayTotal = `$${r.invoiceAmount}`;
                        } else if (r.totalDue?.includes('*')) {
                            displayTotal = insertAtIndex(r?.totalDue, '$', 2);
                        } else if (r?.totalDue !== 'N/A') {
                            displayTotal = `$${r?.totalDue}`;
                        }

                        return {
                            ...r,
                            totalDue: displayTotal,
                            total: dollarUSLocale.format(r.total)
                        }
                    })
    
                    if(fileName === 'Quotes'){
                        newResults = newResults?.map(r => {
                            return {
                                ...r,
                                rateType: r?.vendor?.rateType,
                                carrier: r?.vendor?.name,
                                serviceLevel: r?.vendor?.serviceLevel,
                                transitDays: r?.vendor?.transitDays
                            }
                        })
                    }else if(fileName === 'Invoices'){
                        newResults = newResults?.map(r => {
                            return {
                                ...r,
                                shipperReferenceNumber: `${r.shipperReferenceNumber && `${r.shipperReferenceNumber} - `}${r.shipperReferenceNumber && `${r.consigneeReferenceNumber} - `}${r.billPartyReferenceNumber}`
                            }
                        })
                    }else if(fileName === 'Vendors'){
                        newResults = newResults?.map(r => {
                            return {
                                ...r,
                                type: r?.type[0]?.code
                            }
                        })
                    }else if(fileName === 'Trackings'){
                        newResults = newResults?.map(r => {
                            return {
                                ...r,
                                BOLNumber: r?.BOLWithPrefix
                            }
                        })
                    }
    
                    if(value === 'allpdf'){
                        ExportPdf(fileName === 'Vendors' ? columns?.filter(c => c.title !== 'Restrictions') : columns, newResults, fileName)
                    }else{
                        ExportCsv(fileName === 'Vendors' ? columns?.filter(c => c.title !== 'Restrictions') : columns, newResults, fileName)
                    }
                    setLoading(false)
                }).catch(error => {
                    checkErrorAPICall(error, dispatch, 'Shipping Locations')
                })
            }
        }
    }

    return (
        <Tooltip title={fileName !== 'BatchBooking' && fileName !== 'Rates' ? "Export Data" : "Export All"} open={tooltipOpen}>
            {
                fileName !== 'BatchBooking' && fileName !== 'Rates'
                ? <Select
                    IconComponent={DownloadIcon}
                    className={classes.select}
                    style={{ cursor: 'pointer' }}
                    variant='standard'
                    displayEmpty
                    onChange={(e, value) => downloadFile(e.target.value)}
                    value=""
                    MenuProps={menuProps}
                    onMouseEnter={() => setTooltipOpen(true)}
                    onMouseLeave={() => setTooltipOpen(false)}
                    onOpen={() => setTooltipOpen(false)}
                    disabled={disabled}
                >
                    {fileName === 'ShippingLocations' || fileName === 'Invoices' ? null : <MenuItem value="allpdf">Export All Data to PDF</MenuItem>}
                    <MenuItem value="allcsv">Export All Data to CSV</MenuItem>
                </Select>
                : <Select
                    IconComponent={DownloadIcon}
                    className={classes.select}
                    style={{ cursor: 'pointer' }}
                    variant='standard'
                    displayEmpty
                    onChange={(e, value) => downloadFile(e.target.value)}
                    value=""
                    MenuProps={menuProps}
                    onMouseEnter={() => setTooltipOpen(true)}
                    onMouseLeave={() => setTooltipOpen(false)}
                    onOpen={() => setTooltipOpen(false)}
                    disabled={disabled}
                >
                    <MenuItem value="pdf">Export PDF</MenuItem>
                    <MenuItem value="csv">Export CSV</MenuItem>
                </Select>
            }
        </Tooltip>
    )
}

export default SelectExportType